module.exports = __webpack_public_path__ + "img/file-text.09f0201e.svg";